import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title }) => {
  const isBlogPage = title === "Actualité & Blog";
  const isTrackOrderPage = title === "Suivre ma commande";
  const isContactPage = title === "Contact";
  const isWishlistPage = title === "Ma liste de souhaits";
  const isCartPage = title === "Panier";
  return (
    <div className='breadcrumb breadcrumb-shop mb-0 py-26 bg-main-two-50'>
      <div className='container container-lg'>
        <div className='breadcrumb-wrapper flex-between flex-wrap gap-16'>
          <h6 className={`mb-0 ${isBlogPage ? 'blog-breadcrumb-title' : ''} ${isTrackOrderPage ? 'track-order-breadcrumb-title' : ''} ${isContactPage ? 'contact-breadcrumb-title' : ''} ${isWishlistPage ? 'wishlist-breadcrumb-title' : ''} ${isCartPage ? 'cart-breadcrumb-title' : ''}`}>{title}</h6>
          <ul className='flex-align gap-8 flex-wrap'>
            <li className='text-sm'>
              <Link
                to='/'
                className='text-gray-900 flex-align gap-8 hover-text-main-600'
              >
                <i className='ph ph-house' />
                Accueil
              </Link>
            </li>
            <li className='flex-align'>
              <i className='ph ph-caret-right' />
            </li>
            <li className={`text-sm ${isBlogPage ? 'blog-breadcrumb-title text-main-600' : ''} ${isTrackOrderPage ? 'track-order-breadcrumb-title text-main-600' : ''} ${isContactPage ? 'contact-breadcrumb-title text-main-600' : ''} ${isWishlistPage ? 'wishlist-breadcrumb-title text-main-600' : ''} ${isCartPage ? 'cart-breadcrumb-title text-main-600' : 'text-main-600'}`}> {title} </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
